export default async function (context) {
    const { storefrontAPIToken } = context;
    const graphqlUrl = '/graphql?freqBought';
    const storefrontToken = storefrontAPIToken;

    const cards = document.querySelectorAll('.rental-product__card.loading');
    const totalEl = document.getElementById('add-total');
    const countEl = document.getElementById('add-number');
    const addBtn = document.querySelector('.rental-product__summary button');

    if (!cards.length) return;

    // const productIds = Array.from(cards).map(card => parseInt(card.dataset.productId, 10));

    // const query = `
    //     query GetProducts($ids: [Int!]) {
    //       site {
    //         products(entityIds: $ids) {
    //           edges {
    //             node {
    //               entityId
    //               name
    //               path
    //               defaultImage {
    //                 url(width: 200)
    //                 altText
    //               }
    //             }
    //           }
    //         }
    //       }
    //     }
    // `;

    // const response = await fetch(graphqlUrl, {
    //     method: 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Bearer ${storefrontToken}`,
    //     },
    //     body: JSON.stringify({ query, variables: { ids: productIds } }),
    // });

    // const result = await response.json();
    // const products = result?.data?.site?.products?.edges?.map(e => e.node) || [];

    // products.forEach(product => {
    //     const card = document.querySelector(`.rental-product__card[data-product-id="${product.entityId}"]`);
    //     if (!card) return;

    //     const imageUrl = product.defaultImage?.url || '';
    //     const altText = product.defaultImage?.altText || '';
    //     const name = product.name || '';

    //     card.classList.remove('loading');
    //     card.removeAttribute('data-product-id');
    //     card.setAttribute('data-product-id', product.entityId);

    //     card.innerHTML = `
    //         <div class="rental-product__image">
    //             <img srcset="${imageUrl}" alt="${altText}">
    //         </div>
    //         <span class="product-title">${name}</span>
    //         <button class="ob-btn-border" data="${product.entityId}">Rent This Model</button>
    //     `;
    // });

    // initialize carousels
    initializeCarousel();

    const buttons = document.querySelectorAll('.rental-product__card a[data-rent-button]');

    buttons.forEach((btn) => {
        btn.addEventListener("click", (e) => {
            e.stopPropagation();

            const productId = btn.getAttribute("data-product-id");
            const input = document.querySelector("#product_model");

            if (input) {
                input.value = productId;
            }
        });
    });


    /**
     * Initialize Slick Carousel
     */
    function initializeCarousel() {
        const $carousel = $('.rental-product__grid .grid-wrapper');
        const $progressBar = $carousel.next('.ob-slider-progress');
        const $progressBarLabel = $progressBar.find('.slider__label');

        if ($carousel.hasClass('slick-initialized')) {
            $carousel.slick('unslick');
        }

        $carousel.on('init', (event, slick) => {
            const calc = (1 / (slick.slideCount)) * 100;

            $progressBar
                .css('background-size', `${calc}% 100%`)
                .attr('aria-valuenow', calc);
            $progressBarLabel.text(`${calc}% completed`);
        });

        // Initialize Slick
        $carousel.slick({
            arrows: false,
            dots: false,
            infinite: true,
            mobileFirst: true,
            slide: '.rental-product__card',
            slidesToShow: 1,
            slidesToScroll: 1,
            swipeToSlide: true,
            variableHeight: false,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 850,
                    settings: {
                        arrows: true,
                        slidesToShow: 3,
                    },
                },
                {
                    breakpoint: 1261,
                    settings: {
                        arrows: true,
                        slidesToShow: 4,
                    },
                },
            ],
        });

        const sliderLength = $carousel.length - 1;

        $carousel.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            let calc;

            if (nextSlide === sliderLength) {
                calc = 100;
            } else {
                calc = ((nextSlide + 1) / (slick.slideCount)) * 100;
            }

            $progressBar
                .css('background-size', `${calc}% 100%`)
                .attr('aria-valuenow', calc);
            $progressBarLabel.text(`${calc}% completed`);
        });
    }
}
